import { useCallback } from 'react';

import { Button } from '@bambi/component-library/src/components/Button/Button';

import { RouteTemplatesFilters } from 'src/features/dispatch/DispatchRoute/UnassignedTrips/RouteTemplates/datagrid/RouteTemplatesFilters';

import { useEditRouteTemplateModal } from '../hooks/useEditRouteTemplateModal';

export function RouteTemplateRouteActions() {
  const { editRouteTemplateModal } = useEditRouteTemplateModal();
  const handleClick = useCallback(() => {
    editRouteTemplateModal(undefined);
  }, [editRouteTemplateModal]);
  return (
    <div className="flex flex-row gap-2">
      <RouteTemplatesFilters />
      <Button variant="primary" onClick={handleClick}>
        Add Route Template
      </Button>
    </div>
  );
}
